import { CreateCoverImage } from '../../interfaces/create-custom-product.interface';
import { CustomStore, CustomStoreProduct } from '../interfaces/custom-store.interface';
import { OfferTypeChecker } from '../../../../common/utils/offer-type-util';
import { ProductCardData } from '../../../product-card/product-card-display';
import { appendDuration } from '../../../../common/utils/product-util';
import { formattedAuthors, HE } from '../../../../common/utils/util';
import { getCustomProductUrl } from '../../utils/create-custom-product.util';
import { mapCreateProductFormat, mapCreateTermsToDuration } from '../../mappings/create-custom.mapping';

/**
 * Maps custom store products to product card data.
 *
 * @param products
 * @param store
 */
export const mapCustomStoreProductsToProductCardData = (
  products: CustomStoreProduct[],
  store: CustomStore
): ProductCardData[] => {
  return products.map((product) => {
    const termsAsDuration = mapCreateTermsToDuration(product.terms);

    return {
      kind: 'ProductCardData',
      title: appendDuration(
        termsAsDuration.duration,
        termsAsDuration.durationPeriod,
        termsAsDuration.duration == -1,
        product.title
      ),
      image: product.imageName,
      createCoverImages: buildCreateCoverImages(product.imageName, product.productType),
      url: getCustomProductUrl(store.code, product.isbn13),
      copyRightYear: product.copyrightYear.toString(),
      businessUnit: HE,
      instructorOnly: false,
      format: product.format ? product.format : mapCreateProductFormat(product.deliveryTypes || []),
      isbn: product.isbn10,
      isbn13: product.isbn13,
      contributors: product.authors ? [formattedAuthors(product.authors)] : [],
      description: '',
      gradeLevels: '',
      edition: Number(product.edition),
      quantity: 1,
      mhid: '',
      offerType: product.productType,
      netPrice: product.netPrice,
      optimizedUniqueTitle: '',
      id: '',
      bundleDiscountedPrice: 0,
      isDiscountedBundle: false,
      ...termsAsDuration,
    };
  });
};

/**
 * For Create product, we map the image name to a Create cover image.
 *
 * @param imageName
 * @param productType
 */
function buildCreateCoverImages(imageName?: string, productType?: string): CreateCoverImage[] {
  return imageName && OfferTypeChecker.isCreateEbook(productType) ? [{ httpUrl: imageName }] : [];
}
